var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogNetworkXhr = function SvgLogNetworkXhr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19340_58302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2762 4.276L10.3908 2.39067C10.1408 2.14067 9.8015 2 9.44816 2H4.66683C3.93016 2 3.3335 2.59667 3.3335 3.33333V12.6667C3.3335 13.4033 3.93016 14 4.66683 14H11.3335C12.0702 14 12.6668 13.4033 12.6668 12.6667V5.21867C12.6668 4.86533 12.5262 4.526 12.2762 4.276Z",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 5.33333H10.0002C9.63216 5.33333 9.3335 5.03467 9.3335 4.66667V2",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19340_58302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgLogNetworkXhr as ReactComponent };
export default __webpack_public_path__ + "log-network-xhr.svg";